// TODO: localization
export const displayFiat = (amountFiat: number, rounded = false) => {
  const fractionDigits = rounded ? 0 : 2
  return `$${amountFiat.toLocaleString(navigator.language, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  })}`
}
